import React from "react";
import { graphql } from "gatsby";
import NavHeader from "../components/nav-header";
import BannerImage from "../components/banner-image";
import StandardPage from "../components/standard-page";
import StandardSection from "../components/standard-section";
import Seo from "../components/seo";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ContentRender from "../components/content-render";

export default function About({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const frontmatter = data.file.childMdx.frontmatter;

  return (
    <StandardPage
      header={
        <NavHeader>
          <BannerImage childImageSharp={frontmatter?.banner?.childImageSharp} />
        </NavHeader>
      }
    >
      <StandardSection title={frontmatter?.title}>
        <div className="w-1/2 lg:w-1/3 object-scale-down float-left pr-8">
          <GatsbyImage image={getImage(frontmatter.inline)} />
        </div>

        <ContentRender className="space-y-8">
          {data.file.childMdx.body}
        </ContentRender>
      </StandardSection>

      <Seo
        title={frontmatter?.title}
        cover={frontmatter?.banner}
        slug="/about/"
      />
    </StandardPage>
  );
}

export const pageQuery = graphql`
  query {
    file(relativePath: { eq: "about/main.md" }) {
      childMdx {
        body
        frontmatter {
          title
          banner {
            publicURL
            childImageSharp {
              fluid(quality: 90, maxWidth: 1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          inline {
            childImageSharp {
              gatsbyImageData(width: 500)
            }
          }
        }
      }
    }
  }
`;
